import { useQuery } from "@apollo/client";
import { intl } from "LocaleWrapper";
import { HistoryEntity } from "__generated__/enums";
import { SnapshotRevisionsDocument } from "__generated__/components/entityHistory/graphql/entityHistory.queries.generated";
import RevisionSnapshots from "components/entityHistory/components/RevisionSnapshots";
import EntityHistoryRevisions from "components/entityHistory/components/EntityHistoryRevisions";

const EntitySnapshotHistory = ({ root, rootId }: {
	root: HistoryEntity;
	rootId: number;
}) => {

	const { data, loading, error } = useQuery(SnapshotRevisionsDocument, {
		variables: { root, rootId },
	});

	return (
		<EntityHistoryRevisions
			revisions={data?.snapshotRevisions ?? []}
			loading={loading}
			error={error}
			renderEmptyRemarkTitle={(revision) => {
				if (revision.snapshots.length === 1) {
					return intl.formatMessage({ id: "HISTORY_ENTRY_SINGLE" });
				} else {
					return intl.formatMessage({ id: "HISTORY_ENTRY_MULTIPLE" }, { numberOfEntries: revision.snapshots.length });
				}
			}}
			renderRevision={(revision) => (
				<RevisionSnapshots snapshots={revision.snapshots} revisionId={revision.id} />
			)}
		/>
	);
};

export default EntitySnapshotHistory;
